import config from "../../app.json";
import axios from "axios";

import "./team.scss";
import React, { useState, useEffect, useContext } from "react";
import { Context } from "../../Reducers/Store";
import AlertComponent from "../AlertComponent";
import UserAvatar from "../../Assets/Images/avatar-sc.png";
import InviteTeamMember from "../InviteTeamMember/inviteteammember";
import { Button } from "react-bootstrap";
import Rectangle from "../Rectangle/rectangle";
import IndustryAndTeamMembers from "../IndustryAndTeamMembers/industryandteammembers";

function Team(props) {
  const [state, dispatch] = useContext(Context);
  const [members, setMembers] = useState([]);
  const [showAddNewMembers, setShowAddNewMembers] = useState(false);
  const [membersLoaded, setMembersLoaded] = useState(false);
  const [needMoreSeats, setNeedMoreSeats] = useState(false);
  const [currentProfile, setCurrentProfile] = useState(props.currentProfile);

  const loadMembers = () => {
    axios
      .get(config.API_HM + `/subscriptions/members?orderby=email`)
      .then((result) => {
        const teamMembers = result.data.records.sort((a, b) => {
          if (a.role === `Owner` && !b.role !== `Owner`) {
            return -1;
          }
          if (a.role !== `Owner` && b.role === `Owner`) {
            return 1;
          }

          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }

          return 0;
        });
        setMembers(result.data.records);
      })
      .catch((error) => {
        AlertComponent("Error", error.Message, {
          icon: `error`,
        });
      });
  };

  useEffect(() => {
    loadMembers();
  }, [0]);

  useEffect(() => {
    if (members?.length) {
      setNeedMoreSeats(currentProfile?.subscription?.usersLimit === members.length ?? false);
      setMembersLoaded(true);
    }
  }, [members]);

  const loadProfile = async () => {
    dispatch({ type: "SET_LOADING", payload: true });

    await axios
      .get(config.API_HM + "/profile")
      .then((result) => {
        setCurrentProfile(result.data);
      })
      .catch((error) => {
        AlertComponent("Error", error.message ?? "Something went wrong. Profile could not be loaded. Code: 9", { icon: `error` });
      })
      .finally(() => {
        dispatch({ type: "SET_LOADING", payload: false });
      });
  };
  useEffect(() => {
    if (state?.isLogged) {
      loadProfile();
    }
  }, [state?.isLogged]);

  useEffect(() => {
    if (state?.profile) {
      loadProfile();
    }
  }, [state?.profile]);

  // const handleAddSeats = () => {
  //   AlertComponent("Success", "Need the Add Seats screen");
  // };

  const handleShowInviteMember = () => {
    setShowAddNewMembers(true);
  };

  const handleCloseInviteMember = () => {
    setShowAddNewMembers(false);
  };

  const removeMember = (id) => {
    axios
      .delete(config.API_HM + `/subscriptions/members/` + id)
      .then(() => {
        AlertComponent("Success", "Member was successfully removed");
        loadMembers();
      })
      .catch((error) => {
        AlertComponent("Error", error.Message, {
          icon: `error`,
        });
      });
  };

  const onSaveTeamSettings = () => {
    AlertComponent("Success", "Member settings info has been updated.");
  };

  return (
    <div className="members-tab">
      <InviteTeamMember
        showAddNewMembers={showAddNewMembers}
        handleShowInviteMember={handleShowInviteMember}
        closeAddNewMembers={handleCloseInviteMember}
        setShowAddNewMembers={setShowAddNewMembers}
      />
      <IndustryAndTeamMembers title="Settings" buttonTitle="Save" onSave={onSaveTeamSettings} containerClassName="inner" />
      <div className="team-row">
        <h2>Members</h2>
        {state?.profile?.subscription?.plan === `Business` && membersLoaded && !needMoreSeats && (
          <Button className="add-button manage-user-btn" onClick={handleShowInviteMember}>
            Add Users
          </Button>
        )}
        {/* {state?.profile?.subscription?.plan === `Business` && membersLoaded && needMoreSeats && (
          <Button className="add-button manage-seats-btn" onClick={handleAddSeats}>
            Add Seats
          </Button>
        )} */}
      </div>

      <div className="team-container">
        {members?.map((x) => {
          return (
            <div className="team-card">
              <div className="team-image">
                <img src={UserAvatar} />
              </div>
              <div className="team-content">
                <div className="team-name">
                  <div className="user-name">{x.name}</div>
                  {x.role === "Owner" && <Rectangle title={`Admin`} className="team-admin" />}
                </div>

                <div className="team-login">{x.email}</div>
              </div>
              {x.role !== "Owner" && <div className="team-remove" onClick={() => removeMember(x.userId)}></div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Team;
